module.exports = __webpack_public_path__ + "static/media/dj.a3916af9.svg";